import spaceAdminUrl from './spaceAdminUrl';



export default spaceAdminUrl(() => '/settings/logs');
